const logo1 = '/logos/logo-1.webp';
const logo2 = '/logos/logo-2.webp';
const logo3 = '/logos/logo-3.webp';
const logo4 = '/logos/logo-4.webp';
const logo5 = '/logos/logo-5.webp';
const logo6 = '/logos/logo-6.webp';
const logo7 = '/logos/logo-7.webp';
const logo8 = '/logos/logo-8.webp';
const logo8b = '/logos/logo-8b.webp';
const logo9 = '/logos/logo-9.webp';
const logo10 = '/logos/logo-10.webp';

export const dataLogoCarousel = {
  title: 'empfohlen von',
  logos: [
    {
      src: logo1,
      alt: 'Logo',
      href: 'https://www.aera-online.de',
    },
    {
      src: logo2,
      alt: 'Logo',
      href: 'https://www.dzr.de',
    },
    {
      src: logo3,
      alt: 'Logo',
      href: 'https://meinebfs.de',
    },
    {
      src: logo4,
      alt: 'Logo',
      href: 'https://fair-doctors.de',
    },
    {
      src: logo5,
      alt: 'Logo',
      href: 'https://likha-akademie.de',
    },
    {
      src: logo6,
      alt: 'Logo',
      href: 'https://chrisfengler.de',
    },
    {
      src: logo7,
      alt: 'Logo',
      href: 'https://exisdent.de',
    },
    {
      src: logo8,
      alt: 'Logo',
      href: 'https://abrechen-bar.de',
    },
    {
      src: logo8b,
      alt: 'Logo',
      href: 'https://dentalias.de/',
    },
    {
      src: logo9,
      alt: 'Logo',
      href: 'https://www.zahnzauberwelt-hannover.info',
    },
    {
      src: logo10,
      alt: 'Logo',
      href: 'https://zahnwald-muehlacker.de',
    },
  ],
};
